import { Component, Input, OnInit } from '@angular/core';
import { SharedHttpService } from './../../services/shared-http.service';

@Component({
  selector: 'app-check-type-attachment',
  templateUrl: './check-type-attachment.component.html',
  styleUrls: ['./check-type-attachment.component.scss']
})
export class CheckTypeAttachmentComponent implements OnInit {

  @Input() eCaseId:any; 
  AttachmentArr:any=[];
  constructor(private sharedService:SharedHttpService) { }

  ngOnInit(): void {
    this.sharedService.get(`api/Case/GetCaseTypeAttachmentTypes?eCaseId=${this.eCaseId}`).subscribe(res=>{
      this.AttachmentArr=res;
    })
  }

}
